import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { GlobalConfigContext } from '../ConfigProvider';
var ButtonGroup = function ButtonGroup(_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  var globalConfigValue = React.useContext(GlobalConfigContext);
  return /*#__PURE__*/React.createElement("div", _Object$assign({
    className: "".concat(globalConfigValue.prefixCls, "-btn-group ").concat(globalConfigValue.direction === 'RTL' ? "".concat(globalConfigValue.prefixCls, "-btn-rtl") : "".concat(globalConfigValue.prefixCls, "-btn-ltr"), " ").concat(className || '')
  }, restProps), children);
};
export default ButtonGroup;